var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.user && _vm.user.avatar)?_c('img',{staticClass:"avaimg",attrs:{"src":_vm.user.avatar.image.path,"alt":""}}):_c('img',{staticClass:"avaimg",attrs:{"src":"themes/genius/assets/img/ava2.png","alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }